import { useLiveQuery } from 'dexie-react-hooks';
import { Archive, FileSpreadsheet, Info, SlidersHorizontal, Smartphone, Target, UserRound } from 'lucide-react';
import { PageHeader } from '@/components/PageHeader';
import { Pastilla } from '@/components/Card';
import { Fila, Filas } from '@/components/Fila';
import { leerSettings } from '@/db/schema';
import { datosDePerfilQueFaltan } from '@/domain/perfil';
import { AREAS, disponible } from '@/app/areas';

/** Las áreas de Más, ya disponibles o de fases posteriores (design.md, 12.1). */
const DE_MAS = AREAS.filter((a) => a.ruta.startsWith('/mas/'));
const METAS = DE_MAS.filter((a) => disponible(a));
const FUTURAS = DE_MAS.filter((a) => !disponible(a));

/** Más (diseño Foco): todo en su lugar, en renglones sin recuadro. */
export function MorePage() {
  const ajustes = useLiveQuery(() => leerSettings(), []);
  const nombre = ajustes?.nombre ?? null;
  const tieneNombre = nombre !== null && nombre.trim() !== '';
  // Si falta algún dato del perfil se dice aquí, donde se entra a completarlo (0.11.0)
  const faltan = ajustes === undefined ? [] : datosDePerfilQueFaltan(ajustes);

  return (
    <div>
      <PageHeader titulo="Todo en su lugar." descripcion="Tu espacio también se adapta a ti." />

      <Filas>
        <Fila
          icono={UserRound}
          titulo="Mis datos"
          detalle={
            faltan.length > 0
              ? `${faltan.length === 1 ? 'Falta 1 dato' : `Faltan ${faltan.length} datos`} para tus cálculos`
              : tieneNombre
                ? `${nombre} · perfil completo`
                : 'Nombre, unidades y datos de tus cálculos'
          }
          a="/mas/perfil"
        />
        <Fila icono={Archive} titulo="Respaldos" detalle="Guardar, revisar y recuperar" a="/mas/respaldos" />
        <Fila
          icono={SlidersHorizontal}
          titulo="Ajustes"
          detalle="Apariencia y recordatorios"
          a="/mas/ajustes"
        />
        <Fila icono={Smartphone} titulo="Instalar DuoFit" detalle="En el inicio de tu iPhone" a="/mas/instalar" />
        <Fila
          icono={FileSpreadsheet}
          titulo="Tus datos en Excel"
          detalle="Para mirarlos a tu manera; no es un respaldo"
          a="/mas/excel"
        />
        <Fila icono={Info} titulo="Acerca de" detalle="Privacidad y versión" a="/mas/acerca" />
      </Filas>

      <section className="mt-6" aria-labelledby="titulo-metas">
        <h2 id="titulo-metas" className="antetitulo">
          Tus metas
        </h2>
        <Filas>
          {METAS.map((area) => (
            <Fila key={area.ruta} icono={area.icono} titulo={area.titulo} detalle={area.descripcion} a={area.ruta} />
          ))}
          <Fila icono={Target} titulo="Metas sin plan" detalle="Para los días que no cubre un plan" a="/mas/metas" />
        </Filas>
      </section>

      {FUTURAS.length > 0 && (
        <section className="mt-6" aria-labelledby="titulo-proximamente">
          <h2 id="titulo-proximamente" className="antetitulo">
            Próximamente
          </h2>
          <Filas>
            {FUTURAS.map((area) => (
              <Fila
                key={area.ruta}
                icono={area.icono}
                titulo={area.titulo}
                detalle={area.descripcion}
                a={area.ruta}
                extra={<Pastilla>Fase {area.fase}</Pastilla>}
              />
            ))}
          </Filas>
        </section>
      )}

      <section className="my-6">
        <span className="antetitulo">Un espacio personal</span>
        <p className="mt-[9px] text-[12px] text-texto-suave">
          Tus datos se quedan en tu teléfono. Los de tu pareja, en el suyo.
        </p>
      </section>
    </div>
  );
}
